export enum MachineManufacturerType {
  KARCHER_MACHINE = 1,
  THIRD_PARTY_MANUFACTURER = 2,
}
